// extracted by mini-css-extract-plugin
export default {"error":"UnregisteredPortlet__error--9X0"};